/* action types */
export const GET_DEPOSITS = 'GET_DEPOSITS'
export const FETCH_RATESHEET = 'FETCH_RATESHEET'
export const FETCH_RATESHEET_FULFILLED = 'FETCH_RATESHEET_FULFILLED'
export const FETCH_RATESHEET_FAILED = 'FETCH_RATESHEET_FAILED'

/* actions */
export const getDeposits = payload => ({ type: GET_DEPOSITS, payload })
export const fetchRateSheet = () => ({ type: FETCH_RATESHEET })
export const fetchRateSheetFulfilled = payload => ({
  type: FETCH_RATESHEET_FULFILLED,
  payload,
})
export const fetchRateSheetFailed = payload => ({
  type: FETCH_RATESHEET_FAILED,
  payload,
})



// WEBPACK FOOTER //
// ./src/actions.js